import React from 'react'
import { TouchableOpacity } from 'react-native'
import Icon from 'APP/Converse/Icon'
import Typography from 'APP/Converse/Typography'
import { useTheme } from 'styled-components/native'

// Styling
import { Container, TitleContainer, CloseButton, SecondaryTextContainer, Link } from './style'
import I18n from 'APP/Services/i18n'

// Services
import Analytics from 'APP/Services/Analytics'

const AlertModal = ({
  titleText,
  subtitleText,
  linkText,
  icon,
  iconColor,
  alertStyle,
  style,
  handleDismissModal,
  handleLinkAction,
}) => {
  const theme = useTheme()

  const _handleDismissModal = () => {
    Analytics.trackEvent('button_click', { button_value: 'Dismiss' }, ['banner_context'])
    handleDismissModal()
  }

  const _handleLinkAction = (linkText) => {
    handleLinkAction()
    return () => {
      Analytics.trackEvent(
        'link_text_click',
        {
          linkText: linkText,
        },
        ['banner_context']
      )
    }
  }

  const backgroundColor = theme.colors.bannerBg
  const titleColor = theme.colors[`alertBannerTitle${alertStyle}`]

  return (
    <Container style={[backgroundColor && { backgroundColor }, style]} accessible>
      <CloseButton
        onPress={_handleDismissModal}
        accessibilityLabel={I18n.t('AccessibilityIcons.close')}
      >
        <Icon src="close" variant="materialIcons" size={theme.fonts.fontSize.h2} color="text" />
      </CloseButton>
      <TitleContainer>
        <Typography
          variant="h3"
          color={titleColor}
          style={{ display: 'flex', justifyContent: 'center' }}
        >
          {icon && (
            <Icon
              src={icon}
              variant="ionicons"
              color={iconColor}
              size={theme.fonts.fontSize.large}
              testId="icon"
            />
          )}
          {icon && ' '}
          {titleText}
        </Typography>
      </TitleContainer>
      <SecondaryTextContainer>
        <Typography variant="bodyNormal" style={{ textAlign: 'center' }}>
          {subtitleText}
        </Typography>
        <TouchableOpacity onPress={() => _handleLinkAction(linkText)}>
          <Link variant="subheaderBold">{linkText}</Link>
        </TouchableOpacity>
      </SecondaryTextContainer>
    </Container>
  )
}

export default AlertModal
